export default __webpack_public_path__ + "static/media/calendar-sm.21723e94.svg";